<div class="hover:bg-gray-50 transition-colors">
  <div class="flex items-center-safe justify-between">
    <div class="flex items-start gap-3 flex-1 min-w-0">
      <div class="flex-1 min-w-0">
        <h3 class="font-medium text-gray-900 truncate mb-1">
          {{ control().title || 'usedControls.untitled' | translate }}
        </h3>
        @if (control().tag) {
          <p class="text-sm text-gray-600 truncate mb-2">{{ control().tag }}</p>
        }
      </div>
    </div>
    <div class="flex ml-4 gap-2">
      <button
        (click)="onSelect()"
        class="text-main hover:text-cmi-gray p-2 rounded hover:bg-blue-50 transition-colors"
        [title]="buttonTooltip() | translate">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-5">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5" />
        </svg>
      </button>
    </div>
  </div>
</div>
